import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
const firebaseConfig = {
  apiKey: "AIzaSyA_1aa-wF7VFwNcqR1yho0VFr-ISpuTeMA",
  authDomain: "guatam-codes.firebaseapp.com",
  projectId: "guatam-codes",
  storageBucket: "guatam-codes.appspot.com",
  messagingSenderId: "890050654985",
  appId: "1:890050654985:web:8588cf63a4ee4d534c99d8",
  measurementId: "G-DQ1VHKSLFB"
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore();
